import React from 'react';
import { duration } from 'moment';
import momentTZ from 'moment-timezone';
import PropTypes from 'prop-types';
import { locationIcon, hours, profileIcon, aimIcon } from 'assets/icons';
import styles from './styles.module.css';

export const CalendarCard = ({ groupEx, setIsDetailsOpened }) => {
  const { classInfo, startTime, endTime, date, trainerName, isLive, isVirtual } = groupEx;

  const { club, name, programName } = classInfo;

  const parseAsPacific = time =>
    momentTZ.tz(`${date} ${time}`, 'YYYY-MM-DD HH:mm:ss', 'UTC').tz('America/Los_Angeles');

  const calculateDuration = () => {
    const classDuration = duration(
      parseAsPacific(endTime).valueOf() - parseAsPacific(startTime).valueOf()
    );
    return `(${classDuration.hours() * 60 + classDuration.minutes()}min)`;
  };

  return (
    <div onClick={() => setIsDetailsOpened(true)} className={styles.cardContainer}>
      <div className={styles.column}>
        <h1>{programName || name}</h1>
        <p className={styles.subTitle}>
          <img src={isLive || isVirtual ? aimIcon : locationIcon} alt="location" />
          <span>{isLive || isVirtual ? 'Live Class' : club.name}</span>
        </p>
        <p className={styles.subTitle}>
          <img src={hours} alt="hours" />
          <span>
            {parseAsPacific(startTime).format('h:mma')} {calculateDuration()}
          </span>
        </p>
        <p className={styles.subTitle}>
          {trainerName && (
            <img className={styles.instructorIcon} src={profileIcon} alt="instructor" />
          )}
          <span>{trainerName}</span>
        </p>
      </div>
    </div>
  );
};

CalendarCard.propTypes = {
  groupEx: PropTypes.object.isRequired,
  setIsDetailsOpened: PropTypes.func.isRequired,
};
